import React, { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import { Alert, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconAlertTriangle, IconCheck, IconInfoCircle } from '@tabler/icons-react';

import { useStore } from '../../state';
import { LAYOUT_CONSTANTS } from '../layout/LayoutConstants';

export const AlertDisplay = observer(() => {
  const { alertStore } = useStore();
  const { alert, hideAlert } = alertStore;
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  useEffect(() => {
    if (alert) {
      const timer = setTimeout(() => {
        hideAlert();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [alert, hideAlert]);

  if (!alert) return null;

  const { message, severity } = alert;

  const colorMap = {
    success: 'green',
    info: 'blue',
    warning: 'yellow',
    error: 'red'
  } as const;

  const iconMap = {
    success: <IconCheck size={20} />,
    info: <IconInfoCircle size={20} />,
    warning: <IconAlertTriangle size={20} />,
    error: <IconAlertTriangle size={20} />
  } as const;

  // Calculate bottom offset: add mobile cart height + padding on mobile
  const bottomOffset = isMobile ? LAYOUT_CONSTANTS.MOBILE_CART_HEIGHT + 16 : 16;

  return (
    <Alert
      variant='filled'
      icon={iconMap[severity]}
      title={severity.charAt(0).toUpperCase() + severity.slice(1)}
      color={colorMap[severity]}
      withCloseButton
      onClose={hideAlert}
      style={{
        position: 'fixed',
        bottom: `${bottomOffset}px`,
        right: '16px',
        maxWidth: isMobile ? 'calc(100vw - 32px)' : '400px',
        zIndex: 2000,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)'
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </Alert>
  );
});
